import Vue from "vue";

// When the request succeeds
const success = (response, context) => {
  if (response.data.status === "success") {
    toastr.success("Désynchronisé avec succès");
    window.location.reload();
  }
};

// When the request fails
const failed = (error) => {
  toastr.error(error);
};

export default (context, data) => {
  return Vue.$http
    .post("/rental/desync-airbnb", data)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed(error, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/desyncAirbnb.js